import { LineChart } from "lucide-react"
import { cn } from "@/lib/utils"

export interface ChartContextChipProps {
  label: string
  className?: string
}

/**
 * Compact chip naming the chart context that went out with a sent message —
 * a record of what the AI was given, not a control. What rides with the NEXT
 * message is governed by the composer's tick box (see ChartContextToggle).
 */
export function ChartContextChip({ label, className }: ChartContextChipProps) {
  return (
    <span
      className={cn(
        "ai-capture-chip text-foreground inline-flex items-center gap-1.5 text-caption rounded-md px-2 py-1",
        className,
      )}
    >
      <LineChart size={11} className="shrink-0 text-primary" />
      <span className="truncate max-w-[180px]">{label}</span>
    </span>
  )
}
